import type { HomeType } from '~/composables/useHomeType'

/**
 * Règle d'affichage de la section « Hébergements à découvrir » de l'accueil
 * (4.113.0). L'endpoint `featured` ne sert que des chambres d'hôtes : la section
 * est masquée en mode Gîtes, et masquée aussi quand la liste est vide (API en
 * erreur ou aucune fiche éligible) pour ne jamais afficher de section creuse.
 */
export function shouldShowHomeDiscover(type: HomeType, establishmentCount: number): boolean {
  return type !== 'gite' && establishmentCount > 0
}
